exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".advertising-visuals iframe {\n  vertical-align: top;\n}\n.advertising-visuals div.nodata-container {\n  background-color: white;\n}\n.advertising-visuals div.advert-wrap img {\n  max-width: 100%;\n}\n.advertising-visuals h1.advertising-title {\n  font-size: 5rem;\n}\n.advertising-visuals img {\n  vertical-align: top;\n}\n.advertising-visuals div.ad-lib {\n  max-width: 30%;\n  margin: 0 auto;\n  margin-bottom: 2rem;\n}\n.advertising-visuals div.ad-lib img {\n  max-width: 100%;\n}\n.advertising-visuals div.ad-lib.num-visuals-1, .advertising-visuals div.ad-lib.num-visuals-2 {\n  max-width: 50%;\n}", ""]);

// exports
